import React from "react";

const Contact = () => {
    return (
        <h1>I am the Contact page</h1>
    );
}

export default Contact;